// extracted by mini-css-extract-plugin
export default {"spin":"Loader_spin__ddwRw"};